<div class="create-user-container container-fluid p-4">
  <!-- Page Header -->
  <div class="mb-4">
    <app-page-header section="Administration / Users" pageTitle="Create User"
      subtitle="Grant platform access and define reporting structure" [actions]="headerActions">
    </app-page-header>
  </div>

  <div class="row g-4">
    <!-- Left Column: Form Content -->
    <div class="col-lg-8 col-md-12">
      <form (submit)="$event.preventDefault(); onCreateUser()" novalidate>
        <fieldset [disabled]="creationSuccess || saving" class="border-0 p-0 m-0">
          <!-- Section 01: Identity -->
          <div class="form-section mb-4">
            <div class="section-header d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center gap-2">
                <span class="section-num">01</span>
                <span class="section-title">Identity</span>
              </div>
              <span class="section-subtitle">Personal & contact details</span>
            </div>

            <div class="section-content">
              <app-full-name-input [(value)]="formData.fullName" [hasError]="submitted && fullNameError"
                (valueChange)="fullNameError = false">
              </app-full-name-input>

              <div class="row mt-3">
                <div class="col-md-6 col-12">
                  <app-email-input [(value)]="formData.email" [(validationState)]="emailState">
                  </app-email-input>
                </div>
                <div class="col-md-6 col-12">
                  <app-phone-input [(value)]="formData.phone" [(validationState)]="phoneState">
                  </app-phone-input>
                </div>
              </div>
            </div>
          </div>

          <div class="section-divider"></div>

          <!-- Section 02: Role & Access -->
          <div class="form-section mb-4">
            <div class="section-header d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center gap-2">
                <span class="section-num">02</span>
                <span class="section-title">Role & access</span>
              </div>
              <span class="section-subtitle">Defines what this user can do</span>
            </div>

            <div class="section-content">
              <app-supervisory-level-selector [selectedLevel]="formData.supervisoryLevel"
                [hasError]="submitted && supervisoryLevelError" (roleChange)="onLevelChange($event)">
              </app-supervisory-level-selector>

              <app-role-select [value]="formData.role ? formData.role.id : null" [hasError]="submitted && roleError"
                (valueChange)="onRoleChange($event)">
              </app-role-select>

              <app-access-type-selector [selectedTypes]="[formData.PlatformAccess]"
                (typesChange)="formData.PlatformAccess = $event[0]">
              </app-access-type-selector>
            </div>
          </div>

          <div class="section-divider"></div>

          <!-- Section 03: Reporting Structure -->
          <div class="form-section mb-4">
            <div class="section-header d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center gap-2">
                <span class="section-num">03</span>
                <span class="section-title">Reporting structure</span>
              </div>
              <span class="section-subtitle">Hierarchy & assignment</span>
            </div>

            <div class="section-content">
              <app-supervisor-picker [supervisor]="formData.supervisor" [hasError]="submitted && supervisorError"
                [disabled]="formData.supervisoryLevel === 'L3'"
                [disabledMessage]="'Regional Manager (L3) does not report to anyone'"
                (pickSupervisor)="onPickSupervisor()">
              </app-supervisor-picker>
              @if(showSupervisoryLevelRequiredError) {
              <div class="text-danger small mt-1 mb-2 d-flex align-items-center gap-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                  class="bi bi-exclamation-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path
                    d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                </svg>
                <span>Please select a supervisory level first.</span>
              </div>
              }

              <app-geographic-territory-tree
                [selectedIds]="formData.geographicNodeIds || []"
                [nodes]="geoNodes"
                [loading]="geoLoading"
                (selectionChange)="onGeoSelectionChange($event)"
                (searchChange)="onGeoSearch($event)">
              </app-geographic-territory-tree>
            </div>
          </div>

          <!-- Credentials Info Bar -->
          <div class="info-bar p-3 rounded d-flex align-items-start gap-3 mb-4">
            <!-- <span class="info-icon">🔒</span> -->
            <div class="icon-mask" [style.--icon-url]="'url(assets/icons/lock.svg)'"></div>
            <p class="mb-0 info-text">
              <strong>Initial credentials</strong> will be sent to the email address above once the user is created.
              The user will be required to change their password on first login.
            </p>
          </div>

          <!-- Action Buttons -->
          <!-- <div class="d-flex justify-content-end gap-3 mb-5">
          <button type="button" class="btn btn-outline-secondary px-4 py-2" (click)="onCancel()" [disabled]="saving">
            Cancel
          </button>
          <button type="submit" class="btn btn-teal px-4 py-2" [disabled]="saving">
            <span class="spinner-border spinner-border-sm me-2" role="status" *ngIf="saving"></span>
            {{ saving ? 'Saving...' : 'Create user' }}
          </button>
        </div> -->
        </fieldset>
      </form>
    </div>

    <!-- Right Column: Previews and Validation Summary -->
    <div class="col-lg-4 col-md-12">
      <div class="sticky-top-panel">

        <!-- Validation Summary Card (shown on failed submit) -->
        @if(submitted && !isFormValid() && !saveError) {
        <div class="card border-danger mb-4 validation-summary-card">
          <div
            class="card-header bg-danger bg-opacity-10 text-danger border-danger d-flex align-items-center gap-2 py-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
              class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
              <path
                d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" />
              <path
                d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
            </svg>
            <span class="fw-semibold">{{ validationIssues.length }} issue(s) blocking save</span>
          </div>
          <div class="card-body py-3">
            <ul class="list-unstyled mb-0 d-flex flex-column gap-2">
              @for (issue of validationIssues; track $index) {
              <li class="text-danger d-flex gap-2">
                <span>&rarr;</span>
                <span>{{ issue }}</span>
              </li>
              }
            </ul>
          </div>
        </div>
        }

        <!-- 409 Conflict Panel (shown when saveError is set) -->
        @if(saveError) {
        <div class="card border-warning mb-4 conflict-card">
          <div class="card-body p-4 text-center">
            <!-- Icon -->
            <div class="lock-icon-container mb-3 mx-auto">
              <span class="fs-4">🔒</span>
            </div>

            <h5 class="card-title fw-bold text-dark mb-1">Could not create user</h5>
            <p class="text-muted small mb-4">A conflict was detected at save time</p>

            <!-- Message card -->
            <div class="conflict-detail-card p-3 rounded text-start mb-4">
              <p class="mb-0 text-secondary small">{{ saveError.message }}</p>
            </div>

            <!-- Actions -->
            <div class="d-flex gap-2 justify-content-center mb-3">
              <button type="button" class="btn btn-outline-secondary btn-sm px-3" (click)="onDiscardConflict()">
                Discard
              </button>
              @if(saveError.type === 'phone_conflict') {
              <button type="button" class="btn btn-warning text-white btn-sm px-3" (click)="onEditPhoneConflict()">
                Edit phone
              </button>
              }
              @if (saveError.type === 'email_conflict') {
              <button type="button" class="btn btn-warning text-white btn-sm px-3" (click)="onEditEmailConflict()">
                Edit email
              </button>
              }
            </div>

            <div class="text-muted small border-top pt-3 error-code">
              Error &middot; 409 {{ saveError.code || 'CONFLICT_DUPLICATE' }}
            </div>
          </div>
        </div>
        }

        <!-- Live Preview Panel (Always visible, hidden or placed under conflict if needed, let's keep it visible/below validation cards) -->
        @if(!saveError && !creationSuccess) {
        <div class="card preview-card p-4 mb-4 shadow-sm">
          <h6 class="text-uppercase text-muted fw-bold small-title mb-4">Live Preview</h6>

          <!-- A. User Card Preview -->
          <div class="user-card-preview p-3 d-flex align-items-center gap-3 mb-4">
            <div class="preview-avatar" [class.empty]="!formData.fullName">
              {{ formData.fullName || '—' | initials}}
            </div>
            <div class="overflow-hidden">
              <div class="fw-bold preview-name text-truncate">
                {{ formData.fullName || 'Unnamed user' }}
              </div>
              <div class="preview-role text-muted small text-truncate">
                {{ formData.role ? formData.role.name : 'No role assigned' }}
                @if(formData.supervisor) {
                <span>
                  &middot; reports to {{ formData.supervisor.name }}
                </span>
                }
              </div>
            </div>
          </div>

          <!-- B. Required Fields Tracker -->
          <div class="required-fields-tracker mb-4">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <span class="fw-semibold text-dark small-title">Required Fields</span>
              <span class="badge bg-light text-dark border">{{ filledFieldsCount }}/{{ totalRequiredFields }}</span>
            </div>

            <div class="d-flex flex-column gap-3">
              <!-- Full Name -->
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2">
                  <span class="tracker-status-icon" [ngClass]="getFieldStatus('fullName')">
                    <!-- Custom Icons based on status -->
                  </span>
                  <span class="tracker-label">Full Name</span>
                </div>
                <div>
                  <span class="secondary-text">{{ formData.fullName }}</span>
                </div>
              </div>

              <!-- Email -->
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2">
                  <span class="tracker-status-icon" [ngClass]="getFieldStatus('email')"></span>
                  <span class="tracker-label">Email</span>
                </div>
                <div>
                  <span class="secondary-text">{{ formData.email }}</span>
                </div>
              </div>

              <!-- Phone -->
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2">
                  <span class="tracker-status-icon" [ngClass]="getFieldStatus('phone')"></span>
                  <span class="tracker-label">Phone</span>
                </div>
                <div>
                  <span class="secondary-text">{{ formData.phone }}</span>
                </div>
              </div>

              <!-- Supervisory Level -->
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2">
                  <span class="tracker-status-icon" [ngClass]="getFieldStatus('supervisoryLevel')"></span>
                  <span class="tracker-label">Supervisory Level</span>
                </div>
                <div>
                  @if (formData.supervisoryLevel === 'L3') {
                  <span class="secondary-text">Regional Manager</span>
                  } @else if(formData.supervisoryLevel === 'L2') {
                  <span class="secondary-text">Supervisor</span>
                  } @else if(formData.supervisoryLevel === 'L1') {
                  <span class="secondary-text">Field Agent</span>
                  }
                </div>
              </div>

              <!-- Role -->
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2">
                  <span class="tracker-status-icon" [ngClass]="getFieldStatus('role')"></span>
                  <span class="tracker-label">Role</span>
                </div>
                <div>
                  <span class="secondary-text">{{ formData.role?.name }}</span>
                </div>
              </div>

              <!-- Supervisor -->
              @if(formData.supervisoryLevel !== 'L3') {
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2">
                  <span class="tracker-status-icon" [ngClass]="getFieldStatus('supervisor')"></span>
                  <span class="tracker-label">Supervisor</span>
                </div>
                <div>
                  <span class="secondary-text">{{ formData.supervisor?.name }}</span>
                </div>
              </div>
              }
            </div>
          </div>

          <!-- C. Permissions Preview (shown only when a supervisory level is selected) -->
          @if(formData.supervisoryLevel) {
          <div class="permissions-preview border-top pt-4">
            <div class="fw-semibold text-uppercase text-muted small-title mb-2">
              Permissions Preview &middot; {{ formData.supervisoryLevel === 'L3' ? 'Regional Manager' :
              (formData.supervisoryLevel === 'L2' ? 'Supervisor' : 'Field Agent') }}
            </div>
            <ul class="list-unstyled mb-0 d-flex flex-column gap-2 mt-2">
              @for (perm of ROLE_PERMISSIONS[formData.supervisoryLevel]; track $index) {
              <li class="permission-item d-flex align-items-center gap-2">
                <span class="bullet-dot">●</span>
                <span class="secondary-text">{{ perm }}</span>
              </li>
              }
            </ul>
          </div>
          }
        </div>
        }

        <!-- Success Panel -->
        @if(creationSuccess) {
        <div class="card border-success mb-4 success-card shadow-sm">
          <div class="card-body p-4 text-center">
            <!-- Done Icon Circle -->
            <div class="success-icon-container mb-3 mx-auto">
              <img src="assets/icons/done.svg" alt="Done" class="done-icon" />
            </div>

            <h5 class="card-title fw-bold text-dark mb-1">User Created</h5>
            <p class="fw-semibold text-secondary mb-3">{{ createdUserName }}</p>
            <p class="text-muted small mb-4">
              Initial credentials sent to <strong class="text-dark">{{ createdUserEmail }}</strong>
            </p>

            <!-- Actions -->
            <div class="d-flex gap-2 justify-content-center mb-3">
              <button type="button" class="btn btn-outline-teal" (click)="onResetForm()">
                Create another user
              </button>
              <button type="button" class="btn btn-teal" (click)="redirectToUserList()">
                Go to user list
              </button>
            </div>

            <!-- Timer -->
            <div class="text-muted small border-top pt-3 redirect-timer">
              Auto redirect in {{ remainingSeconds }} seconds
            </div>
          </div>
        </div>
        }

      </div>
    </div>
  </div>

  <!-- Supervisor Picker Modal -->
  <app-supervisor-picker-modal [isOpen]="showSupervisorModal" [supervisoryLevel]="formData.supervisoryLevel"
    [selectedSupervisorId]="formData.supervisorId" (supervisorSelected)="onSupervisorSelected($event)"
    (closed)="closeSupervisorModal()">
  </app-supervisor-picker-modal>

</div>